import { useEffect, useRef, useState } from "react";
import { CustomSearchableDropdown } from "../../../components/CustomSearchableDropdown"
import { getBrandsByYear } from "../../../services/VehicleDetails";
import { baseURL } from "../../../config/api";
import { TireSizeHelpPopup } from "../../../components/TireSizeHelpPopup";
import { getPositions } from "../../../services/Tires";
import useConfirm from "../../../hook/useConfirm";


const currentYear = new Date().getFullYear();
const startYear = currentYear + 1;       // one year extra
const endYear = currentYear - 50;        // 50 years back

const yearOptions: any[] = [];
let yearCount = 0;
for (let year = startYear; year >= endYear; year--) {
    yearCount += 1;
    yearOptions.push({ value: yearCount, label: year.toString() });
}


type VehiclesTiresProps = {
    vehicleId: null | number;
    selectedVehicleYear: null | number;
    selectedBrandId: null | number;
    selectedModelId: null | number;
    selectedBrandValue: string;
    selectedModelValue: string;
    primaryKey: number;
    vehicleTrimID: null | number;
    vehicleTrimLabel: string;
    selectedTireSizeId: null | number;
    selectedTireWidth: string;
    selectedTireRatio: string;
    selectedTireDiameter: string;
    selectedRearTireSizeId: null | number;
    selectedRearTireWidth: string;
    selectedRearTireRatio: string;
    selectedRearTireDiameter: string;
    selectedIsComercial: boolean;
    selectedTireCount: number;
    selectedIsRequestedTireSize: boolean;
    selectedRequestedTireWidth: string;
    selectedRequestedTireRatio: string;
    selectedRequestedTireDiameter: string;
    allServices: any[];
    selectedPositions: number[];
    isTireChangeService: boolean;
    selectedIsCantFindIt: boolean;
    status: string;
    goToNextPage: () => void;
    getDataFromVehicles: (
        selectedVehicleYear: number | null,
        selectedBrandId: number | null,
        selectedModelId: number | null,
        selectedBrandValue: string,
        selectedModelValue: string,
        vehicleTrimID: number | null,
        vehicleTrimLabel: string,
        selectedTireSizeId: null | number,
        selectedTireWidth: string,
        selectedTireRatio: string,
        selectedTireDiameter: string,
        selectedRearTireSizeId: null | number,
        selectedRearTireWidth: string,
        selectedRearTireRatio: string,
        selectedRearTireDiameter: string,
        selectedIsComercial: boolean,
        selectedTireCount: number,
        selectedIsRequestedTireSize: boolean,
        selectedRequestedTireWidth: string,
        selectedRequestedTireRatio: string,
        selectedRequestedTireDiameter: string,
        selectedPositions: number[],
        selectedServices: any[],
        selectedIsCantFindit: boolean,
        selectedIsRearTireSize: boolean
    ) => void;
}

export const VehiclesTires = ({
    vehicleId,
    selectedVehicleYear,
    selectedBrandId,
    selectedModelId,
    primaryKey,
    selectedBrandValue,
    selectedModelValue,
    vehicleTrimID,
    vehicleTrimLabel,
    selectedTireSizeId,
    selectedTireWidth,
    selectedTireRatio,
    selectedTireDiameter,
    selectedRearTireSizeId,
    selectedRearTireWidth,
    selectedRearTireRatio,
    selectedRearTireDiameter,
    selectedIsComercial,
    selectedTireCount,
    selectedIsRequestedTireSize,
    selectedRequestedTireWidth,
    selectedRequestedTireRatio,
    selectedRequestedTireDiameter,
    allServices,
    selectedPositions,
    isTireChangeService,
    selectedIsCantFindIt,
    status,
    goToNextPage,
    getDataFromVehicles
}: VehiclesTiresProps) => {
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [brands, setBrands] = useState<any[]>([]);
    const [brandLabel, setBrandLabel] = useState<string>("");
    const [modelLabel, setModelLabel] = useState<string>("");
    const [vehicleYear, setVehicleYear] = useState<number | null>(null);
    const [brandId, setBrandId] = useState<number | null>(null);
    const [modelId, setModelId] = useState<number | null>(null);
    const [tireCount, setTireCount] = useState<number>(1);
    const [selectedServices, setSelectedServices] = useState<any[]>([]);
    const [loadingBrand, setLoadingBrand] = useState(false);
    const [trimId, setTrimId] = useState<any>(null);
    const [trimLabel, setTrimLabel] = useState<string>("");
    //model
    const [modelLoadingMore, setModelLoadingMore] = useState(false);
    const [modelPage, setModelPage] = useState(1);
    const [modelHasMore, setModelHasMore] = useState(true);
    const [modelInitialLoading, setModelInitialLoading] = useState(false);
    const [modelResults, setModelResults] = useState<any[]>([]);
    const [modelSearchQuery, setModelSearchQuery] = useState<string>("");
    //trim
    const [trimLoadingMore, setTrimLoadingMore] = useState(false);
    const [trimPage, setTrimPage] = useState(1);
    const [trimHasMore, setTrimHasMore] = useState(true);
    const [trimInitialLoading, setTrimInitialLoading] = useState(false);
    const [trimResults, setTrimResults] = useState<any[]>([]);
    const [trimSearchQuery, setTrimSearchQuery] = useState<string>("");

    //Tire Size width
    const [tireSizeId, setTireSizeId] = useState<any>(null);
    const [tireWidthLabel, setTireWidthLabel] = useState<string>("");
    const [tireWidthLoadingMore, setTireWidthLoadingMore] = useState(false);
    const [tireWidthPage, setTireWidthPage] = useState(1);
    const [tireWidthHasMore, setTireWidthHasMore] = useState(true);
    const [tireWidthInitialLoading, setTireWidthInitialLoading] = useState(false);
    const [tireWidthResults, setTireWidthResults] = useState<any[]>([]);
    const [tireWidthSearchQuery, setTireWidthSearchQuery] = useState<string>("");
    //Tire Size ratio
    const [tireRatioLabel, setTireRatioLabel] = useState<string>("");
    const [tireRatioLoadingMore, setTireRatioLoadingMore] = useState(false);
    const [tireRatioPage, setTireRatioPage] = useState(1);
    const [tireRatioHasMore, setTireRatioHasMore] = useState(true);
    const [tireRatioInitialLoading, setTireRatioInitialLoading] = useState(false);
    const [tireRatioResults, setTireRatioResults] = useState<any[]>([]);
    const [tireRatioSearchQuery, setTireRatioSearchQuery] = useState<string>("");

    //Tire Size diameter
    const [tireDiameterLabel, setTireDiameterLabel] = useState<string>("");
    const [tireDiameterLoadingMore, setTireDiameterLoadingMore] = useState(false);
    const [tireDiameterPage, setTireDiameterPage] = useState(1);
    const [tireDiameterHasMore, setTireDiameterHasMore] = useState(true);
    const [tireDiameterInitialLoading, setTireDiameterInitialLoading] = useState(false);
    const [tireDiameterResults, setTireDiameterResults] = useState<any[]>([]);
    const [tireDiameterSearchQuery, setTireDiameterSearchQuery] = useState<string>("");

    const [rearTireSizeId, setRearTireSizeId] = useState<any>(null);
    //Rear Tire Width
    const [rearTireWidthLabel, setRearTireWidthLabel] = useState<string>("");
    const [rearTireWidthLoadingMore, setRearTireWidthLoadingMore] = useState(false);
    const [rearTireWidthPage, setRearTireWidthPage] = useState(1);
    const [rearTireWidthHasMore, setRearTireWidthHasMore] = useState(true);
    const [rearTireWidthInitialLoading, setRearTireWidthInitialLoading] = useState(false);
    const [rearTireWidthResults, setRearTireWidthResults] = useState<any[]>([]);
    const [rearTireWidthSearchQuery, setRearTireWidthSearchQuery] = useState<string>("");

    //Rear Tire Ratio
    const [rearTireRatioLabel, setRearTireRatioLabel] = useState<string>("");
    const [rearTireRatioLoadingMore, setRearTireRatioLoadingMore] = useState(false);
    const [rearTireRatioPage, setRearTireRatioPage] = useState(1);
    const [rearTireRatioHasMore, setRearTireRatioHasMore] = useState(true);
    const [rearTireRatioInitialLoading, setRearTireRatioInitialLoading] = useState(false);
    const [rearTireRatioResults, setRearTireRatioResults] = useState<any[]>([]);
    const [rearTireRatioSearchQuery, setRearTireRatioSearchQuery] = useState<string>("");

    //Rear Tire Diameter
    const [rearTireDiameterLabel, setRearTireDiameterLabel] = useState<string>("");
    const [rearTireDiameterLoadingMore, setRearTireDiameterLoadingMore] = useState(false);
    const [rearTireDiameterPage, setRearTireDiameterPage] = useState(1);
    const [rearTireDiameterHasMore, setRearTireDiameterHasMore] = useState(true);
    const [rearTireDiameterInitialLoading, setRearTireDiameterInitialLoading] = useState(false);
    const [rearTireDiameterResults, setRearTireDiameterResults] = useState<any[]>([]);
    const [rearTireDiameterSearchQuery, setRearTireDiameterSearchQuery] = useState<string>("");

    const [isCantFindIt, setIsCantFindIt] = useState<boolean>(false);
    const [showTireSizeHelpPopup, setShowTireSizeHelpPopup] = useState<boolean>(false);
    const [isCommercial, setIsCommercial] = useState<boolean>(false);
    const [positions, setPositions] = useState<any[]>([]);
    const [isRearTireSize, setIsRearTireSize] = useState<boolean>(false);
    const [isRequestedTireSize, setIsRequestedTireSize] = useState<boolean>(false);

    const [requestedTireWidth, setRequestedTireWidth] = useState<string>("");
    const [requestedTireRatio, setRequestedTireRatio] = useState<string>("");
    const [requestedTireDiameter, setRequestedTireDiameter] = useState<string>("");
    const [selectedServicePositions, setSelectedServicePosition] = useState<any[]>([]);
    const isHydratingRef = useRef(true);

    useEffect(() => {
        if (selectedVehicleYear && selectedVehicleYear > 0 && selectedBrandId && selectedBrandValue && selectedModelId && selectedModelValue) {
            setVehicleYear(selectedVehicleYear);
            setBrandLabel(selectedBrandValue);
            setBrandId(selectedBrandId);
            setModelLabel(selectedModelValue);
            setModelId(selectedModelId);
            setModelSearchQuery(selectedModelValue);

            if (vehicleTrimID && vehicleTrimLabel) {
                setTrimId(vehicleTrimID);
                setTrimLabel(vehicleTrimLabel);
                setTrimSearchQuery(vehicleTrimLabel);
            }
        }
        setIsCantFindIt(selectedIsCantFindIt);

        if (selectedTireSizeId && selectedTireSizeId > 0) {
            setTireSizeId(selectedTireSizeId);
            setTireWidthLabel(selectedTireWidth);
            setTireWidthSearchQuery(selectedTireWidth);
            setTireRatioLabel(selectedTireRatio);
            setTireRatioSearchQuery(selectedTireRatio);
            setTireDiameterLabel(selectedTireDiameter);
            setTireDiameterSearchQuery(selectedTireDiameter);
        }

        if (selectedRearTireSizeId && selectedRearTireSizeId > 0) {
            setIsRearTireSize(true);
            setRearTireSizeId(selectedRearTireSizeId);
            setRearTireWidthLabel(selectedRearTireWidth);
            setRearTireWidthSearchQuery(selectedRearTireWidth);
            setRearTireRatioLabel(selectedRearTireRatio);
            setRearTireRatioSearchQuery(selectedRearTireRatio);
            setRearTireDiameterLabel(selectedRearTireDiameter);
            setRearTireDiameterSearchQuery(selectedRearTireDiameter);

        }

        if (selectedIsRequestedTireSize) {
            setIsRequestedTireSize(selectedIsRequestedTireSize);
            setRequestedTireWidth(selectedRequestedTireWidth);
            setRequestedTireRatio(selectedRequestedTireRatio);
            setRequestedTireDiameter(selectedRequestedTireDiameter);
        }
        setIsCommercial(selectedIsComercial);
        setTireCount(selectedTireCount);
        setSelectedServices(() => allServices?.map((item: any) => {
            return {
                ...item,

            }
        }))

        setSelectedServicePosition(() => selectedPositions?.map((item: any) => {
            return {
                ...item
            }
        }));

        queueMicrotask(() => {
            isHydratingRef.current = false;
        });
    }, [
        primaryKey,
        selectedVehicleYear,
        selectedBrandValue,
        selectedIsCantFindIt,
        selectedBrandId,
        selectedModelId,
        selectedModelValue,
        vehicleTrimID,
        vehicleTrimLabel,
        selectedTireSizeId,
        selectedTireWidth,
        selectedTireRatio,
        selectedTireDiameter,
        selectedRearTireSizeId,
        selectedRearTireWidth,
        selectedRearTireRatio,
        selectedRearTireDiameter,
        selectedIsComercial,
        selectedTireCount,
        selectedIsRequestedTireSize,
        selectedRequestedTireWidth,
        selectedRequestedTireRatio,
        selectedRequestedTireDiameter,
        selectedPositions,
        allServices
    ]);



    const toggle = (id: number, serviceId: number) => {
        setSelectedServicePosition(prev => {
            const existing = prev.find(
                item => item.position === id && item.serviceId === serviceId
            );

            if (existing) {
                // Toggle existing
                return prev.filter(item =>
                    item.position !== id || item.serviceId !== serviceId
                );
            }

            // Add new
            return [
                ...prev,
                {
                    id: 0,
                    position: id,
                    serviceId
                }
            ];
        });
    };



    useEffect(() => {
        if (vehicleYear) {
            setLoadingBrand(true);
            getBrandsByYear()
                .then((data) => {
                    const brandsOptions = data?.map((item: any) => {
                        return {
                            value: item?.makeID,
                            label: item?.name
                        }
                    })
                    setBrands(brandsOptions);
                    setLoadingBrand(false);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        else if (!isHydratingRef.current) {
            setBrandId(null);
            setBrandLabel("");
            setBrands([]);
        }
    }, [vehicleYear])


    useEffect(() => {
        getPositions("TirePosition")
            .then((data) => {
                setPositions(data.reverse());
            }).catch((error) => {
                console.error(error);
                setPositions([]);
            })
    }, [])

    useEffect(() => {
        if (!isHydratingRef.current && !brandId) {
            setModelPage(1)
            setModelHasMore(true);
            setModelResults([]);
            setModelSearchQuery("");
            setModelId(null);
            setModelLabel("");
        }
    }, [brandId])

    useEffect(() => {
        if (isHydratingRef.current) return;
        if (!brandLabel.length) {
            setBrandId(null);
            setBrandLabel("");

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandLabel])


    useEffect(() => {
        if (!isHydratingRef.current && !modelId) {
            setTrimPage(1)
            setTrimHasMore(true);
            setTrimResults([]);
            setTrimSearchQuery("");
            setTrimId(null);
            setTrimLabel("");
        }
    }, [modelId])


    useEffect(() => {
        if (isHydratingRef.current) return;
        if (!modelLabel.length && modelSearchQuery.length) {
            setModelId(null);
            setModelLabel("");
            setModelSearchQuery("");
            setModelPage(1);
            setModelHasMore(true);
            setModelResults([]);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelLabel, modelSearchQuery])

    useEffect(() => {
        if (!isHydratingRef.current && !trimId) {
            setTireSizeId(null);
        }
    }, [trimId])

    useEffect(() => {
        if (isHydratingRef.current) return;
        if (!isCantFindIt) {
            setVehicleYear(null);
            setBrandId(null);
            setBrandLabel("");
            setModelId(null);
            setModelLabel("");
            setBrands([]);
            setModelResults([]);
            setTrimId(null);
            setTrimLabel("");
            setTrimResults([]);
            setIsRearTireSize(false)
            setIsCommercial(false);

            setTireSizeId(null);
            setTireWidthPage(1)
            setTireWidthHasMore(true);
            setTireWidthResults([]);
            setTireWidthSearchQuery("");
            setTireWidthLabel("");

            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");

            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }

    }, [isCantFindIt])

    useEffect(() => {
        if (isHydratingRef.current) return;
        if (!tireSizeId) {
            setIsRearTireSize(false)
            setIsCommercial(false);

            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }
    }, [tireSizeId])

    useEffect(() => {
        if (isHydratingRef.current) return;
        if ((!tireWidthLabel.length && !tireWidthSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setTireWidthPage(1)
            setTireWidthHasMore(true);
            setTireWidthResults([]);
            setTireWidthSearchQuery("");
            setTireWidthLabel("");

            setTireSizeId(null)
            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tireWidthLabel, tireWidthSearchQuery, modelId])


    useEffect(() => {
        if (isHydratingRef.current) return;
        if ((!tireRatioLabel.length && !tireRatioSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setTireRatioPage(1)
            setTireRatioHasMore(true);
            setTireRatioResults([]);
            setTireRatioSearchQuery("");
            setTireRatioLabel("");

            setTireSizeId(null)
            setTireDiameterPage(1)
            setTireDiameterHasMore(true);
            setTireDiameterResults([]);
            setTireDiameterSearchQuery("");
            setTireDiameterLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tireRatioLabel, tireRatioSearchQuery, modelId])

    useEffect(() => {
        if (isHydratingRef.current) return;
        if ((!rearTireWidthLabel.length && !rearTireWidthSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setRearTireWidthPage(1)
            setRearTireWidthHasMore(true);
            setRearTireWidthResults([]);
            setRearTireWidthSearchQuery("");
            setRearTireWidthLabel("");

            setRearTireSizeId(null)
            setRearTireRatioPage(1)
            setRearTireRatioHasMore(true);
            setRearTireRatioResults([]);
            setRearTireRatioSearchQuery("");
            setRearTireRatioLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rearTireWidthLabel, rearTireWidthSearchQuery, modelId])

    useEffect(() => {
        if (isHydratingRef.current) return;
        if ((!rearTireRatioLabel.length && !rearTireRatioSearchQuery.length) || (!isCantFindIt && !modelId)) {
            setRearTireRatioPage(1)
            setRearTireRatioHasMore(true);
            setRearTireRatioResults([]);
            setRearTireRatioSearchQuery("");
            setRearTireRatioLabel("");

            setRearTireSizeId(null)
            setRearTireDiameterPage(1)
            setRearTireDiameterHasMore(true);
            setRearTireDiameterResults([]);
            setRearTireDiameterSearchQuery("");
            setRearTireDiameterLabel("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rearTireRatioLabel, rearTireRatioSearchQuery, modelId])

    useEffect(() => {
        if (!isHydratingRef.current && !isRearTireSize) {
            setRearTireSizeId(null);
            setRearTireWidthPage(1)
            setRearTireWidthHasMore(true);
            setRearTireWidthResults([]);
            setRearTireWidthSearchQuery("");
            setRearTireWidthLabel("");

            setRearTireRatioPage(1)
            setRearTireRatioHasMore(true);
            setRearTireRatioResults([]);
            setRearTireRatioSearchQuery("");
            setRearTireRatioLabel("");

            setRearTireDiameterPage(1)
            setRearTireDiameterHasMore(true);
            setRearTireDiameterResults([]);
            setRearTireDiameterSearchQuery("");
            setRearTireDiameterLabel("");
        }
    }, [isRearTireSize])


    useEffect(() => {
        if (isHydratingRef.current) return;
        if (!rearTireSizeId) {

            setRearTireDiameterPage(1)
            setRearTireDiameterHasMore(true);
            setRearTireDiameterResults([]);
            setRearTireDiameterSearchQuery("");
            setRearTireDiameterLabel("");
        }
    }, [rearTireSizeId])

    const modelFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!brandId) return;
        if (modelLoadingMore) return;
        if (!modelHasMore && !isFresh) return;
        if (isFresh) {
            setModelInitialLoading(true);
            setModelHasMore(true);
        } else {
            setModelLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}models/GetModelsPagingByMakeIdAndSearchWithModelName?modelName=${modelSearchQuery.trim()
            }&page=${pageToLoad}&size=${pageSize}&makeId=${brandId}`
            : `${baseURL}models/GetModelsPagingByMakeId/${pageToLoad},${pageSize},${brandId}`;

        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.models?.map((item: any) => {
                return {
                    value: item?.modelID,
                    label: item?.name
                }
            }) || [];

            setModelResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setModelHasMore(list.length === pageSize);
            setModelPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setModelLoadingMore(false);
            setModelInitialLoading(false);
        }
    };

    const trimFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!modelId) return;
        if (trimLoadingMore) return;
        if (!trimHasMore && !isFresh) return;
        if (isFresh) {
            setTrimInitialLoading(true);
            setTrimHasMore(true);
        } else {
            setTrimLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? `${baseURL}vehicleTrims/GetVehicleTrimsPagingByModelIdAndSearchWithTrimName?trimName=${trimSearchQuery.trim()
            }&page=${pageToLoad}&size=${pageSize}&modelId=${modelId}`
            : `${baseURL}vehicleTrims/GetVehicleTrimsPagingByModelId/${pageToLoad},${pageSize},${modelId}`;


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.vehicleTrims?.map((item: any) => {
                return {
                    value: item?.vehicleTrimID,
                    label: item?.trimName
                }
            }) || [];

            setTrimResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTrimHasMore(list.length === pageSize);
            setTrimPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTrimLoadingMore(false);
            setTrimInitialLoading(false);
        }

    };

    const tireWidthFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!isCantFindIt && !modelId) return;
        if (tireWidthLoadingMore) return;
        if (!tireWidthHasMore && !isFresh) return;
        if (isFresh) {
            setTireWidthInitialLoading(true);
            setTireWidthHasMore(true);
        } else {
            setTireWidthLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&position=${false}` :

                    !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&position=${false}`
                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthSearchQuery.trim()}&position=${false}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&position=${false}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.metricWidth)
                }
            }) || [];

            setTireWidthResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireWidthHasMore(list.length === pageSize);
            setTireWidthPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireWidthLoadingMore(false);
            setTireWidthInitialLoading(false);
        }

    };


    const tireRatioFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!tireWidthLabel) return;
        if (tireRatioLoadingMore) return;
        if (!tireRatioHasMore && !isFresh) return;
        if (isFresh) {
            setTireRatioInitialLoading(true);
            setTireRatioHasMore(true);
        } else {
            setTireRatioLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&position=${false}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&position=${false}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${false}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&position=${false}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.aspectRatio)
                }
            }) || [];

            setTireRatioResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireRatioHasMore(list.length === pageSize);
            setTireRatioPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireRatioLoadingMore(false);
            setTireRatioInitialLoading(false);
        }


    };


    const tireDiameterFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!tireRatioLabel || !tireWidthLabel) return;
        if (tireDiameterLoadingMore) return;
        if (!tireDiameterHasMore && !isFresh) return;
        if (isFresh) {
            setTireDiameterInitialLoading(true);
            setTireDiameterHasMore(true);
        } else {
            setTireDiameterLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${false}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${false}`



        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.diameter)
                }
            }) || [];

            setTireDiameterResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setTireDiameterHasMore(list.length === pageSize);
            setTireDiameterPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setTireDiameterLoadingMore(false);
            setTireDiameterInitialLoading(false);
        }

    };


    const rearTireWidthFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {

        if (rearTireWidthLoadingMore) return;
        if (!rearTireWidthHasMore && !isFresh) return;
        if (isFresh) {
            setRearTireWidthInitialLoading(true);
            setRearTireWidthHasMore(true);
        } else {
            setRearTireWidthLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${true}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthSearchQuery.trim()}&position=${true}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&position=${true}` :

                    !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&position=${true}`
                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthSearchQuery.trim()}&position=${true}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByMetricWidth?page=${pageToLoad}&size=${pageSize}&position=${true}`




        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.metricWidth)
                }
            }) || [];

            setRearTireWidthResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setRearTireWidthHasMore(list.length === pageSize);
            setRearTireWidthPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setRearTireWidthLoadingMore(false);
            setRearTireWidthInitialLoading(false);
        }

    };


    const rearTireRatioFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!rearTireWidthLabel) return;
        if (rearTireRatioLoadingMore) return;
        if (!rearTireRatioHasMore && !isFresh) return;
        if (isFresh) {
            setRearTireRatioInitialLoading(true);
            setRearTireRatioHasMore(true);
        } else {
            setRearTireRatioLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${true}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${true}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&position=${true}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&position=${true}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioSearchQuery.trim()}&position=${true}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByAspectRatio?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&position=${true}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.aspectRatio)
                }
            }) || [];

            setRearTireRatioResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setRearTireRatioHasMore(list.length === pageSize);
            setRearTireRatioPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setRearTireRatioLoadingMore(false);
            setRearTireRatioInitialLoading(false);
        }

    };


    const rearTireDiameterFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (!rearTireRatioLabel || !rearTireWidthLabel) return;
        if (rearTireDiameterLoadingMore) return;
        if (!rearTireDiameterHasMore && !isFresh) return;
        if (isFresh) {
            setRearTireDiameterInitialLoading(true);
            setRearTireDiameterHasMore(true);
        } else {
            setRearTireDiameterLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch && !isCantFindIt && trimId > 0
            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${true}`

            : isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${true}`

                : !isSearch && !isCantFindIt && trimId > 0 ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&vehicleTrimId=${trimId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${true}`

                    : !isSearch && !isCantFindIt && (trimId === 0 || trimId === null) ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?$page=${pageToLoad}&size=${pageSize}&modelId=${modelId}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${true}`

                        : isSearch && isCantFindIt
                            ? `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&diameter=${tireDiameterSearchQuery.trim()}&position=${true}`
                            : `${baseURL}tireFitments/SearchTireFitmentsByDiameter?page=${pageToLoad}&size=${pageSize}&metricWidth=${tireWidthLabel}&aspectRatio=${tireRatioLabel}&position=${true}`


        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.tireFitments?.map((item: any) => {
                return {
                    value: item?.tireFitmentID,
                    label: String(item?.diameter)
                }
            }) || [];

            setRearTireDiameterResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setRearTireDiameterHasMore(list.length === pageSize);
            setRearTireDiameterPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setRearTireDiameterLoadingMore(false);
            setRearTireDiameterInitialLoading(false);
        }

    };



    const validateServices = () => {

        const showError = (message: string) => {
            setConfirmPopup(true);
            setConfirmData({
                title: message,
                confirmBtn: "Ok",
                isConfirm: (callback: any) => callback()
            });
        };

        for (const service of selectedServices) {

            const selectedCount = selectedServicePositions.filter(
                pos => pos.serviceId === service.id
            ).length;

            if (service.requiresTireCount) {

                if (!service.quantity || service.quantity <= 0) {
                    showError("Please select tire count.");
                    return false;
                }

                if (selectedCount !== service.quantity) {
                    showError("Tire positions must match the tire count.");
                    return false;
                }
            }

        }



        return true;
    };

    const handleNext = () => {

        if ((!primaryKey || status === "Scheduled" || status === "Queued" || status === "InProgress") && !isRequestedTireSize) {
            if (!isCantFindIt && (!vehicleYear || !brandId || !modelId) && isTireChangeService) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select all vehicles details.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (!isCantFindIt && (!vehicleYear || !brandId || !modelId) && !isTireChangeService) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select all vehicles details.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && !isCantFindIt && vehicleYear && brandId && modelId && !isRearTireSize && !tireSizeId && !isRequestedTireSize) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select a tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && !isCantFindIt && vehicleYear && brandId && modelId && isRearTireSize && !rearTireSizeId && !isRequestedTireSize) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select a rear tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && isCantFindIt && !isRearTireSize && !isRequestedTireSize && !tireSizeId) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select a tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && isCantFindIt && isRearTireSize && !isRequestedTireSize && !rearTireSizeId) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select rear tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && !isCantFindIt && !isRearTireSize && !isRequestedTireSize && !tireSizeId) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select a tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && !isCantFindIt && isRearTireSize && !isRequestedTireSize && !rearTireSizeId) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select rear tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }

            if (isTireChangeService && isRequestedTireSize && (!requestedTireWidth.length || !requestedTireRatio.length || !requestedTireDiameter.length)) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please enter valid requested tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }



            if (isTireChangeService && !isRearTireSize && tireSizeId && !isRequestedTireSize && (!tireWidthLabel.length || !tireRatioLabel.length || !tireDiameterLabel.length)) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select valid tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }


            if (isTireChangeService && isRearTireSize && tireSizeId && rearTireSizeId && !isRequestedTireSize && (!tireWidthLabel.length || !tireRatioLabel.length || !tireDiameterLabel.length || !rearTireWidthLabel.length || !rearTireRatioLabel.length || !rearTireDiameterLabel.length)) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select valid front and rear tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }


            if (isTireChangeService && isRearTireSize && !tireSizeId && rearTireSizeId && !isRequestedTireSize && (!rearTireWidthLabel.length || !rearTireRatioLabel.length || !rearTireDiameterLabel.length)) {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Please select valid rear tire size.",
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {
                        callback();
                    }
                })
                return;
            }



            const isValid = validateServices();
            if (!isValid) return;
            getDataFromVehicles(
                vehicleYear,
                brandId,
                modelId,
                brandLabel,
                modelLabel,
                trimId,
                trimLabel,
                tireSizeId,
                tireWidthLabel,
                tireRatioLabel,
                tireDiameterLabel,
                rearTireSizeId,
                rearTireWidthLabel,
                rearTireRatioLabel,
                rearTireDiameterLabel,
                isCommercial,
                tireCount,
                isRequestedTireSize,
                requestedTireWidth,
                requestedTireRatio,
                requestedTireDiameter,
                selectedServicePositions,
                selectedServices,
                isCantFindIt,
                isRearTireSize
            );
            goToNextPage();

        }
        else {
            goToNextPage();
        }
    }

    const updateServiceTireQuantity = (count: number, id: number) => {
        setSelectedServices(prev => {

            const exists = prev.some(item => item.id === id);

            if (exists) {
                // 🔥 Update existing item
                return prev.map(item =>
                    item.id === id
                        ? { ...item, quantity: count }
                        : item
                );
            }

            // 🔥 Add new item if not exists
            return [
                ...prev,
                {
                    id,
                    quantity: count
                }
            ];
        });
    };

    return (
        <>
            <div className="w-full mt-2">
                <div className={`w-full pb-4`}>
                    <div className="flex">
                        <div className="mt-2 p-2 w-[50%] space-y-2">
                            {
                                !isCantFindIt && (
                                    <>
                                        <div className={`flex items-center ${!isCantFindIt ? "justify-between" : "justify-start"}`}>
                                            <span className="text-sm font-semibold text-gray-800">
                                                Vehicle Details
                                            </span>
                                            {
                                                (!isCantFindIt && isTireChangeService) && (
                                                    <span onClick={() => {
                                                        setIsCantFindIt(true);
                                                        setVehicleYear(null);
                                                    }} className="text-xs underline hover:cursor-pointer text-blue-600">Book with tire size</span>
                                                )
                                            }
                                        </div>

                                        <div className="grid grid-cols-3 gap-3 border-b py-4 relative">
                                            <CustomSearchableDropdown
                                                label="Year"
                                                options={yearOptions}
                                                value={vehicleYear}
                                                setValue={setVehicleYear}
                                                onChange={setVehicleYear}
                                                placeholder="Search Year"
                                                selectedOptionLabel={vehicleYear ? String(vehicleYear) : ""}
                                            />

                                            <CustomSearchableDropdown
                                                label="Make"
                                                options={brands}
                                                value={brandId}
                                                setValue={setBrandId}
                                                selectedOptionLabel={brandLabel}
                                                setSelectedOptionLabel={setBrandLabel}
                                                onChange={(value: number, label?: string) => {
                                                    setBrandId(value);
                                                    if (label)
                                                        setBrandLabel(label)
                                                }}
                                                placeholder="Search Make"
                                                loading={loadingBrand}
                                                setIsCantFindIt={setIsCantFindIt}
                                                isAdmin={true}
                                            />

                                            <CustomSearchableDropdown
                                                label="Model"
                                                value={modelId}
                                                setValue={setModelId}
                                                selectedOptionLabel={modelLabel}
                                                setSelectedOptionLabel={setModelLabel}
                                                placeholder="Search Model"
                                                onDemandData={true}
                                                setResults={setModelResults}
                                                results={modelResults}
                                                fetchData={modelFetchData}
                                                setSearchQuery={setModelSearchQuery}
                                                searchQuery={modelSearchQuery}
                                                initialLoading={modelInitialLoading}
                                                loadingMore={modelLoadingMore}
                                                page={modelPage}
                                                setPage={setModelPage}
                                                hasMore={modelHasMore}
                                                setHasMore={setModelHasMore}
                                                setIsCantFindIt={setIsCantFindIt}
                                                isAdmin={true}
                                            />
                                        </div>
                                    </>
                                )
                            }

                            {
                                (((modelId && modelId > 0) || trimId) && isTireChangeService && !isCantFindIt) && (
                                    <>
                                        <span className="text-sm font-semibold inline-block text-gray-800">
                                            Select Trim
                                        </span>
                                        <div className="border-b pb-4 relative">
                                            <CustomSearchableDropdown
                                                label="Trim (Optional)"
                                                value={trimId}
                                                setValue={setTrimId}
                                                selectedOptionLabel={trimLabel}
                                                setSelectedOptionLabel={setTrimLabel}
                                                placeholder="Search Trim"
                                                onDemandData={true}
                                                setResults={setTrimResults}
                                                results={trimResults}
                                                fetchData={trimFetchData}
                                                setSearchQuery={setTrimSearchQuery}
                                                searchQuery={trimSearchQuery}
                                                initialLoading={trimInitialLoading}
                                                loadingMore={trimLoadingMore}
                                                page={trimPage}
                                                setPage={setTrimPage}
                                                hasMore={trimHasMore}
                                                setHasMore={setTrimHasMore}
                                                setIsCantFindIt={setIsCantFindIt}
                                            />
                                        </div>

                                    </>
                                )
                            }

                            {
                                (((modelId !== null && modelId > 0) || isCantFindIt) && isTireChangeService && !isRequestedTireSize) && (
                                    <>
                                        <div className={`flex items-center ${isCantFindIt ? "justify-between" : "justify-start"}`}>
                                            <span className="text-sm font-semibold inline-block text-gray-800">
                                                Select {isRearTireSize ? "Front" : ""} Tire Size
                                            </span>

                                            {
                                                isCantFindIt && (
                                                    <span onClick={() => {
                                                        setIsCantFindIt(false);
                                                        setVehicleYear(null);
                                                    }} className="text-xs underline hover:cursor-pointer text-blue-600">Book with vehicle details</span>
                                                )
                                            }

                                        </div>

                                        <div className="border-b pb-4 relative">
                                            <div className="grid grid-cols-3 gap-3">
                                                <CustomSearchableDropdown
                                                    label="Width"
                                                    selectedOptionLabel={tireWidthLabel}
                                                    setSelectedOptionLabel={setTireWidthLabel}
                                                    placeholder="Search Width"
                                                    onDemandData={true}
                                                    setResults={setTireWidthResults}
                                                    results={tireWidthResults}
                                                    fetchData={tireWidthFetchData}
                                                    setSearchQuery={setTireWidthSearchQuery}
                                                    searchQuery={tireWidthSearchQuery}
                                                    initialLoading={tireWidthInitialLoading}
                                                    loadingMore={tireWidthLoadingMore}
                                                    page={tireWidthPage}
                                                    setPage={setTireWidthPage}
                                                    hasMore={tireWidthHasMore}
                                                    setHasMore={setTireWidthHasMore}
                                                />

                                                <CustomSearchableDropdown
                                                    label="Ratio"
                                                    selectedOptionLabel={tireRatioLabel}
                                                    setSelectedOptionLabel={setTireRatioLabel}
                                                    placeholder="Search Ratio"
                                                    onDemandData={true}
                                                    setResults={setTireRatioResults}
                                                    results={tireRatioResults}
                                                    fetchData={tireRatioFetchData}
                                                    setSearchQuery={setTireRatioSearchQuery}
                                                    searchQuery={tireRatioSearchQuery}
                                                    initialLoading={tireRatioInitialLoading}
                                                    loadingMore={tireRatioLoadingMore}
                                                    page={tireRatioPage}
                                                    setPage={setTireRatioPage}
                                                    hasMore={tireRatioHasMore}
                                                    setHasMore={setTireRatioHasMore}
                                                />

                                                <CustomSearchableDropdown
                                                    label="Diameter"
                                                    value={tireSizeId}
                                                    setValue={setTireSizeId}
                                                    selectedOptionLabel={tireDiameterLabel}
                                                    setSelectedOptionLabel={setTireDiameterLabel}
                                                    placeholder="Search Diameter"
                                                    onDemandData={true}
                                                    setResults={setTireDiameterResults}
                                                    results={tireDiameterResults}
                                                    fetchData={tireDiameterFetchData}
                                                    setSearchQuery={setTireDiameterSearchQuery}
                                                    searchQuery={tireDiameterSearchQuery}
                                                    initialLoading={tireDiameterInitialLoading}
                                                    loadingMore={tireDiameterLoadingMore}
                                                    page={tireDiameterPage}
                                                    setPage={setTireDiameterPage}
                                                    hasMore={tireDiameterHasMore}
                                                    setHasMore={setTireDiameterHasMore}
                                                />
                                            </div>

                                            <div className={`flex items-center justify-between mt-2`}>
                                                {
                                                    !isRearTireSize && (
                                                        <span onClick={() => {
                                                            setIsRearTireSize(true)
                                                        }} className="text-xs underline hover:cursor-pointer text-blue-600">+ add a rear tire size</span>
                                                    )
                                                }

                                                <span onClick={() => {
                                                    setShowTireSizeHelpPopup(true)
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">Need help finding tire size?</span>
                                            </div>
                                        </div>

                                    </>
                                )
                            }

                            {
                                (isRearTireSize && (isCantFindIt || (modelId !== null && modelId > 0)) && isTireChangeService && !isRequestedTireSize) && (
                                    <>
                                        <div className={`flex items-center`}>
                                            <span className="text-sm inline-block font-semibold text-gray-800">
                                                Select Rear Tire Size
                                            </span>
                                        </div>

                                        <div className="border-b pb-4 relative">
                                            <div className="grid grid-cols-3 gap-3 pb-4 relative">
                                                <CustomSearchableDropdown
                                                    label="Width"
                                                    selectedOptionLabel={rearTireWidthLabel}
                                                    setSelectedOptionLabel={setRearTireWidthLabel}
                                                    placeholder="Search Width"
                                                    onDemandData={true}
                                                    setResults={setRearTireWidthResults}
                                                    results={rearTireWidthResults}
                                                    fetchData={rearTireWidthFetchData}
                                                    setSearchQuery={setRearTireWidthSearchQuery}
                                                    searchQuery={rearTireWidthSearchQuery}
                                                    initialLoading={rearTireWidthInitialLoading}
                                                    loadingMore={rearTireWidthLoadingMore}
                                                    page={rearTireWidthPage}
                                                    setPage={setRearTireWidthPage}
                                                    hasMore={rearTireWidthHasMore}
                                                    setHasMore={setRearTireWidthHasMore}
                                                />

                                                <CustomSearchableDropdown
                                                    label="Ratio"
                                                    selectedOptionLabel={rearTireRatioLabel}
                                                    setSelectedOptionLabel={setRearTireRatioLabel}
                                                    placeholder="Search Ratio"
                                                    onDemandData={true}
                                                    setResults={setRearTireRatioResults}
                                                    results={rearTireRatioResults}
                                                    fetchData={rearTireRatioFetchData}
                                                    setSearchQuery={setRearTireRatioSearchQuery}
                                                    searchQuery={rearTireRatioSearchQuery}
                                                    initialLoading={rearTireRatioInitialLoading}
                                                    loadingMore={rearTireRatioLoadingMore}
                                                    page={rearTireRatioPage}
                                                    setPage={setRearTireRatioPage}
                                                    hasMore={rearTireRatioHasMore}
                                                    setHasMore={setRearTireRatioHasMore}
                                                />

                                                <CustomSearchableDropdown
                                                    label="Diameter"
                                                    value={rearTireSizeId}
                                                    setValue={setRearTireSizeId}
                                                    selectedOptionLabel={rearTireDiameterLabel}
                                                    setSelectedOptionLabel={setRearTireDiameterLabel}
                                                    placeholder="Search Diameter"
                                                    onDemandData={true}
                                                    setResults={setRearTireDiameterResults}
                                                    results={rearTireDiameterResults}
                                                    fetchData={rearTireDiameterFetchData}
                                                    setSearchQuery={setRearTireDiameterSearchQuery}
                                                    searchQuery={rearTireDiameterSearchQuery}
                                                    initialLoading={rearTireDiameterInitialLoading}
                                                    loadingMore={rearTireDiameterLoadingMore}
                                                    page={rearTireDiameterPage}
                                                    setPage={setRearTireDiameterPage}
                                                    hasMore={rearTireDiameterHasMore}
                                                    setHasMore={setRearTireDiameterHasMore}
                                                />
                                            </div>

                                            <div className={`flex items-center justify-between mt-2`}>
                                                <span onClick={() => {
                                                    setIsRearTireSize(false)
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">Remove</span>

                                                <span onClick={() => {
                                                    setShowTireSizeHelpPopup(true)
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">Need help finding tire size?</span>
                                            </div>
                                        </div>

                                    </>
                                )
                            }


                            {
                                (((modelId !== null && modelId > 0) || isCantFindIt) && isRequestedTireSize) && isTireChangeService && (
                                    <>
                                        <div className={`flex items-center`}>
                                            <span className="text-sm inline-block font-semibold text-gray-800">
                                                Requested Tire Size
                                            </span>
                                        </div>

                                        <div className="border-b pb-4 relative">

                                            <div className="grid grid-cols-3 gap-3 pb-4 relative">
                                                <div>
                                                    <span className="text-sm text-gray-700">Width*</span>
                                                    <div className={`border border-gray-300 rounded-xl p-[5px] text-sm bg-white`}>
                                                        <input
                                                            type="text"
                                                            placeholder="Width"
                                                            className="w-full outline-none p-2 "
                                                            value={requestedTireWidth}
                                                            readOnly
                                                            onChange={(e) => {
                                                                setRequestedTireWidth(e.target.value)
                                                            }}


                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <span className="text-sm text-gray-700">Ratio*</span>
                                                    <div className={`border border-gray-300 rounded-xl p-[5px] text-sm bg-white`}>
                                                        <input
                                                            type="text"
                                                            placeholder="Ratio"
                                                            className="w-full outline-none p-2 "
                                                            value={requestedTireRatio}
                                                            readOnly
                                                            onChange={(e) => {
                                                                setRequestedTireRatio(e.target.value)
                                                            }}


                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <span className="text-sm text-gray-700">Diameter*</span>
                                                    <div className={`border border-gray-300 rounded-xl p-[5px] text-sm bg-white`}>
                                                        <input
                                                            type="text"
                                                            placeholder="Diameter"
                                                            className="w-full outline-none p-2 "
                                                            value={requestedTireDiameter}
                                                            readOnly
                                                            onChange={(e) => {
                                                                setRequestedTireDiameter(e.target.value)
                                                            }}


                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`flex items-center justify-between mt-2`}>
                                                <span onClick={() => {
                                                    setIsRequestedTireSize(false)
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">tire is available</span>

                                                <span onClick={() => {
                                                    setShowTireSizeHelpPopup(true)
                                                }} className="text-xs underline hover:cursor-pointer text-blue-600">Need help finding tire size?</span>
                                            </div>
                                        </div>

                                    </>
                                )
                            }




                            <div className="border-b pb-4 relative">
                                <label className="flex items-center gap-2 cursor-pointer select-none">
                                    <input
                                        type="checkbox"
                                        className="h-4 w-4 cursor-pointer"
                                        checked={isCommercial}
                                        onChange={(e) => setIsCommercial(e.target.checked)}
                                    />
                                    <span className="text-sm font-medium text-gray-700">
                                        Is Commercial?
                                    </span>
                                </label>
                            </div>




                            {
                                allServices?.map((service: any, index: number) => {
                                    if (!service?.requiresTireCount) return null;

                                    return (
                                        <div key={index} className="pb-2 border-b space-y-2">
                                            <label className="w-full text-sm inline-block font-semibold text-gray-800">
                                                {service?.serviceName} - Tire Count*
                                            </label>
                                            <select
                                                value={selectedServices?.find((item: any) => item?.id === service?.id)?.quantity}
                                                onChange={(e) => updateServiceTireQuantity(Number(e.target.value), service?.id)}
                                                className="w-[200px] border border-gray-300 rounded-xl px-3 py-4 text-sm outline-none focus:border-primary bg-white"
                                            >
                                                {Array.from({ length: 5 }, (_, i) => i + 1).map((count) => (
                                                    <option key={count} value={count}>
                                                        {count}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )

                                })
                            }

                            {
                                allServices?.map((service: any, index: number) => {
                                    if (!service?.requiresTireCount) return null;

                                    return (
                                        <div key={index} className="space-y-2 pb-2 border-b">
                                            <span className="text-sm inline-block font-semibold text-gray-800">
                                                {service?.serviceName} - Tire Position(s)*
                                            </span>
                                            <div className="grid grid-cols-2 gap-4 text-center">
                                                {positions?.map((pos: any, index: number) => (
                                                    <button
                                                        key={index}
                                                        onClick={() => toggle(pos.statusID, service?.id)}
                                                        className={`border rounded-lg px-4 py-3 text-sm font-medium
                                                        transition-all
                                                        ${selectedServicePositions?.find((item: any) => item?.position === pos.statusID && item?.serviceId === service?.id)
                                                                ? "bg-primary text-white border-primary"
                                                                : "bg-white border-gray-300 text-gray-700 hover:border-primary"
                                                            }
                                                   `}
                                                    >
                                                        {pos.statusValue}
                                                    </button>
                                                ))}
                                            </div>

                                        </div>
                                    )

                                })
                            }

                            <div className="flex mt-6">
                                <button
                                    type="button"
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    onClick={() => { handleNext() }}
                                >
                                    Next
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <TireSizeHelpPopup showPopup={showTireSizeHelpPopup} setShowPopup={setShowTireSizeHelpPopup} />
        </>

    )
}